<template>
  <div class="header">
    <div class="head">
      <div class="head-left">
        <img v-if="back" class="back" @click="backPath()" src="../../static/image/back.png" alt="">
      </div>
      <div class="head-title">
        {{ title }}
      </div>
      <div class="head-right">
        <div class="language" v-if="language">
          <img class="flag" src="../../static/flags/China.jpg" alt="">
          <el-select class="language" v-model="labguageActive" placeholder="请选择">
            <el-option v-for="item in languageTotal" :key="item.abbr" :label="item.name" :value="item.abbr">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/utils/params'
export default {
  props: {
    back: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    language: {
      type: Boolean,
      default: false,
    },
    closeDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languageTotal: global.languageTotal,
      labguageActive: 'zh'
    };
  },
  computed: {

  },
  methods: {
    backPath() {
      if (this.closeDrawer) {
        this.$emit("close")
      } else {
        this.$router.back()
      }
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  background: #101014;

  .head {
    display: flex;
    padding: 17px 0;
    justify-content: space-between;

    .head-left {
      width: 80px;
      padding: 0 18px;
      display: flex;
      align-items: center;

      .back {
        display: block;
        width: 17px;
        margin-right: 10px;
      }

      span {
        &:nth-of-type(2) {
          margin: 0 8px;
          color: #2c3e50;
        }
      }
    }

    .head-title {
      text-align: center;
      font-size: 16px;
      color: #FFF;
    }

    .head-right {
      width: 80px;
      padding: 0 18px;
      font-size: 20px;

      .language {
        display: flex;
        align-items: center;
      }

      .flag {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }

      /deep/.language {
        .el-input__inner {
          background: transparent;
          border: none;
          width: 120px;
          color: #ffad00;
          text-align: center;
          padding-left: 0;
        }

        .el-icon-arrow-up:before {
          color: #ffad00;
        }
      }
    }
  }
}
</style>
